import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import cx from 'classnames';
import { userActions, SupportContactArea } from '../..';
import { utilService, history } from '../../../_helpers';
import './UserLoginPage.scss';
import { tenantService } from '../../Tenant';
import withLiveUpdateHook from '../../Proof/LiveUpdateWrapper';
import { withRouter } from 'react-router-dom';
import withNoAuthNav from '../../_shared/Nav/withNoAuthNav';
import { withAppWrapperContext } from '../../../AppWrapper';

class OktaAuthLanding extends React.Component {
    constructor(props) {
        super(props);
        const subdomain = window.location.host.split('.')[0];
        this.state = {
            username: ''
        };           
    }

    getQueryParam(param, decode = true) {
        const hash = window.location.hash;
        const queryStart = hash.indexOf('?');
        if (queryStart === -1) return null;
        const params = new URLSearchParams(hash.substring(queryStart));
        const value = params.get(param);
        return value ? (decode ? decodeURIComponent(value) : value) : null;
    }

    async componentDidMount() {
        const strUrl = window.location.href;
        if(strUrl.includes("AutheToken")!= -1){
            const params = strUrl.split("AutheToken=");
            const autheToken =  params.length > 1? params[1]: undefined;
            const returnPath = this.getQueryParam('returnPath', false);
            
            if(autheToken != undefined){
                //var user = await userActions.redirectToOktaLogin(autheToken); 
                var user = await this.props.dispatch(
                    userActions.redirectToOktaLogin(autheToken)
                );
                
                if (user && user.success) {
                    const updateUser = this.props?.globalContext?.updateUser;
                    if (updateUser) {
                        updateUser(user, true);
                    }                                     
                    var { from } = this.props.location.state || {
                        from: { pathname: '/dashboard/folders' }
                    };
                    if (returnPath) {
                        from = { pathname: returnPath };
                    }
                    history.push({ ...from, hasBackRoute: false });
                }           
            }
        }     
    }

    
    render() {
        const {            
            username
        } = this.state;
        return (
            <div className="mrnda-main-content padding-2x">                
            </div>
        );
    }
}

function mapStateToProps(state) {
    console.log('IN Login:');
    console.log(state);
    const { authentication } = state;
    return {
        authentication: authentication.user ? authentication.user.authData : {}
    };
}

const withAppWrapper = withAppWrapperContext(OktaAuthLanding);
const withLiveUpdate = withLiveUpdateHook(withAppWrapper);
const connectedUserLandingPage = withNoAuthNav(connect(mapStateToProps)(withRouter(withLiveUpdate)));
export { connectedUserLandingPage as OktaAuthLanding };
